import { AssetStatusInterface } from "../../models/AssetModel/AssetStatus";
import client from "../client";

class AssetStatusesService {
  async GetAll(page: number, pageSize: number) {
    try {
      let url = `/api/AssetStatuses`;
      if (page > 0 && pageSize > 0) {
        url += `?page=${page}&pageSize=${pageSize}`;
      }
      const { data } = await client.get<AssetStatusInterface[]>(url);
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetById(id: string) {
    try {
      let url = `/api/AssetStatuses/getbyid/${id}`;

      const { data } = await client.get<AssetStatusInterface>(url);

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Save(customer: AssetStatusInterface) {
    try {
      let url = `/api/AssetStatuses`;

      const { data } = await client.post<AssetStatusInterface>(url, customer);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async Update(id: string, customer: AssetStatusInterface) {
    try {
      let url = `/api/AssetStatuses/update/${id}`;

      const { data } = await client.post<AssetStatusInterface>(url, customer);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async Remove(id: string) {
    try {
      let url = `api/AssetStatuses/remove/${id}`;
      await client.post<AssetStatusInterface>(url, { url: "" });
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new AssetStatusesService();
